import api from "../../Api";
import { BaseService } from "../../BaseService";

const URL = "financial-agent-categories";

export class FinancialAgentCategoriesService extends BaseService {
  async list(params: any): Promise<any[]> {
    try {
      return this.handleResponse(await api.post(`${URL}/list`, params));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async create(params: any): Promise<any> {
    try {
      return this.handleResponse(await api.post(`${URL}/create`, params));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async delete(id: number): Promise<any> {
    try {
      return this.handleResponse(await api.delete(`${URL}/delete/${id}`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async activate(id: number): Promise<any> {
    try {
      return this.handleResponse(await api.patch(`${URL}/activate/${id}`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async deactivate(id: number): Promise<any> {
    try {
      return this.handleResponse(await api.patch(`${URL}/deactivate/${id}`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }
}
